module.exports = __webpack_public_path__ + "img/card_img_3.2d563237.png";